export const STICKY_ALERT_TYPE = {
  TEST: 'TEST',
  BASIC: 'BASIC',
  NOTIFICATION: 'NOTIFICATION',
  MESSAGE: 'MESSAGE',
} as const;

type ObjectValues<T> = T[keyof T];

export type StickyAlertType = ObjectValues<typeof STICKY_ALERT_TYPE>;
